import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import TagManager from "react-gtm-module";

import "./index.css";
import App from "./App";
import ScrollToTop from "./components/scroll/ScrollToTop";
import * as serviceWorker from "./serviceWorker";

TagManager.initialize({ gtmId: "AW-11079987946" });

createRoot(document.getElementById("root")).render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <ScrollToTop />
    <App />
  </BrowserRouter>
);

serviceWorker.unregister();
